<template>

    
        <!-- Modal -->
        <!-- This example requires Tailwind CSS v2.0+ -->
            <div class="fixed z-10  inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">


                <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <div class="md:text-left h-full w-full inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-6/12 " role="dialog" aria-modal="true" aria-labelledby="modal-headline">

                    <create-user v-on:evento="emitIsOpen()"></create-user>

                    <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                        <button  @click="emitIsOpen()" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                            Cancel
                        </button>
                    </div>

             

                </div>
            </div>
            </div>
            <!-- close Modal -->


</template>

<script>

export default {

  data() {
    return {

    };
  },

  methods: {

       emitIsOpen() {
         this.$emit('event')
      }
  }
};
</script>
